<div class="flag-box">

  <div (click)="onChangeIdioma('pt')" >

    <svg class="flag" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
    <defs>
      <clipPath id="circleClip">
        <circle cx="45" cy="45" r="45"/>
      </clipPath>
    </defs>
    <g clip-path="url(#circleClip)">
      <rect width="90" height="90" fill="#009739"/>
      <path fill="#ffd900" d="M45 10L79.794 45L45 80L10.206 45z"/>
      <circle cx="45" cy="45" r="18" fill="#002776"/>
      <path fill="#fff" d="M45 27a18 18 0 1 0 0 36 18 18 0 0 0 0-36zm0 32.4a14.4 14.4 0 1 1 0-28.8 14.4 14.4 0 0 1 0 28.8z"/>
      <path fill="#002776" d="M45 27a18 18 0 1 0 0 36 18 18 0 0 0 0-36zm0 32.4a14.4 14.4 0 1 1 0-28.8 14.4 14.4 0 0 1 0 28.8z"/>
    </g>
  </svg>
</div>

<div (click)="onChangeIdioma('en')" >
<svg class="flag" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <clipPath id="circleClipUSA">
      <circle cx="50" cy="50" r="50"/>
    </clipPath>
  </defs>
  <g clip-path="url(#circleClipUSA)">
    <rect width="100" height="100" fill="#fff"/>
    <rect y="14.3" width="100" height="14.3" fill="#bf0a30"/>
    <rect y="42.9" width="100" height="14.3" fill="#bf0a30"/>
    <rect y="71.4" width="100" height="14.3" fill="#bf0a30"/>
    <rect width="40" height="25" fill="#002868"/>
    <g fill="#fff">
      <path id="starUSA" d="M10 0L3.82 11.22L-6.18-7.22L6.18-7.22L-3.82 11.22z"/>
      <use href="#starUSA" x="8" y="5" transform="scale(0.4)"/>
      <use href="#starUSA" x="16" y="5" transform="scale(0.4)"/>
      <use href="#starUSA" x="24" y="5" transform="scale(0.4)"/>
      <use href="#starUSA" x="32" y="5" transform="scale(0.4)"/>
      <use href="#starUSA" x="4" y="10" transform="scale(0.4)"/>
      <use href="#starUSA" x="12" y="10" transform="scale(0.4)"/>
      <use href="#starUSA" x="20" y="10" transform="scale(0.4)"/>
      <use href="#starUSA" x="28" y="10" transform="scale(0.4)"/>
      <use href="#starUSA" x="36" y="10" transform="scale(0.4)"/>
    </g>
  </g>
</svg>

</div>

<div (click)="onChangeIdioma('es')">

  <svg class="flag" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <defs>
      <clipPath id="circleClipSpain">
        <circle cx="50" cy="50" r="50"/>
      </clipPath>
    </defs>
    <g clip-path="url(#circleClipSpain)">
      <rect width="100" height="100" fill="#c4122d"/>
      <rect y="25" width="100" height="50" fill="#ffc400"/>
    </g>
  </svg>
</div>

</div>



